import React, { Component } from 'react';
import { connect } from 'react-redux';
import { encrypt } from '../../config/lib';
import {Container, Row, Col} from 'react-bootstrap'
import { getDataPortfolio } from '../../config/redux/action'
//import Form from "../../components/form";
import CustomLoading from "../../components/CustomLoading"
import Portfolio from "../../components/portfolio";

class PortfolioDashboard extends Component {
    state = {
        portfolios: [],
        doneStatus: undefined,
        loadingStatus: undefined,
        fullWidth: false
    }

    async componentDidMount() {
        await this.loadDataPortfolio()
    }

    loadDataPortfolio = async() => {
        this.setState({loadingStatus: true})
        let encryptedkuncika = encrypt("silvesteraprilianta")
        const resDataPortfolio = await this.props.getDataPortfolio({kuncika:encryptedkuncika}).catch (err => err)
        if (resDataPortfolio) {
            this.setState({portfolios: resDataPortfolio, doneStatus: true})
        }
    }

    render() {
        return(
            <div className={this.props.type !== 'page' ? 'section-padding section' : null}>
                {
                        (!this.state.doneStatus) ?
                            <div style={{alignContent:'center'}}>
                                <CustomLoading status={true}></CustomLoading>
                            </div>
                        :   
                            <Container fluid={!!this.state.fullWidth} className={this.state.fullWidth ? 'p-0' : null}>
                                <Row className={'row-7 portfolio-column-three'}>
                                    {this.state.portfolios.map(dt => (
                                    <Col key={dt.id} md={6} lg={4} className={'mb-15'}>
                                        <Portfolio
                                            id={dt.id}
                                            data={dt}
                                            title={dt.name}
                                            thumb={dt.datamediaportfolio && dt.datamediaportfolio.length > 0 ? dt.datamediaportfolio[0].url : ""}
                                            category={dt.type_portfolio} 
                                            variant={'column'}
                                        />
                                    </Col>
                                ))}
                                </Row>
                            </Container>
                    }
            </div>
        )
    }
}

const reduxDispatch = (dispatch) => ({
    getDataPortfolio: (data) => dispatch(getDataPortfolio(data))
})

export default connect (null, reduxDispatch) (PortfolioDashboard);